/* Poveștile Tale: intenție de hover pentru meniul desktop + fixuri header (aditiv, 2026-07-09).
   NU modifică componentele Horizon: interceptează pointerenter/pointerleave pe window-capture
   (rulează ÎNAINTEA delegatului document-capture din component.js) și re-dispatch-uiește
   PointerEvent-uri sintetice marcate. Fără acest fișier, meniul funcționează stock.
   1) grace la închidere (280ms) + dwell la comutarea între frați (180ms) => diagonala nu mai pică;
   2) Escape închide submeniul desktop;
   3) re-măsurare overflow-list după document.fonts.ready (fixul „Mai multe"/drawer aleator);
   4) opțiunile selectului de limbă devin RO/EN (value rămâne intact). */
(() => {
  /* 0. Drawerul coșului NU trebuie să persiste deschis între navigări:
     Horizon salvează starea în sessionStorage['theme-drawer-open'] și
     re-deschide drawerul pe fiecare pagină (strângând layoutul la ~960px).
     Îl lăsăm să se deschidă DOAR la add-to-cart (în pagina curentă). */
  try {
    const key = sessionStorage.getItem('theme-drawer-open');
    if (key && key.indexOf('cart') !== -1) {
      sessionStorage.removeItem('theme-drawer-open');
      const cd = document.getElementById('cart-drawer');
      if (cd && cd.hasAttribute('open')) {
        cd.removeAttribute('open');
        const dlg = cd.querySelector('dialog[open]');
        if (dlg && dlg.close) dlg.close();
        const pw = document.querySelector('.page-wrapper');
        if (pw) pw.classList.remove('page-wrapper--drawer-open');
      }
    }
  } catch (e) {
    /* storage indisponibil = comportament stock */
  }

  /* 0b. Fade-up la scroll (direcția de design: mișcare lentă, organică).
     Failure-safe: clasa .pt-reveal (opacity 0) se aplică DOAR aici, din JS,
     și DOAR secțiunilor aflate sub fold la încărcare => fără JS totul e vizibil,
     hero/LCP neatins, zero CLS. În starea finală transform:none (nu 0px),
     ca să nu rupă position:sticky din interiorul secțiunilor. */
  try {
    if (
      !matchMedia('(prefers-reduced-motion: reduce)').matches &&
      'IntersectionObserver' in window
    ) {
      const mainEl = document.getElementById('MainContent');
      if (mainEl) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((en) => {
              if (!en.isIntersecting) return;
              en.target.classList.add('pt-reveal--in');
              io.unobserve(en.target);
            });
          },
          { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
        );
        mainEl.querySelectorAll(':scope > .shopify-section').forEach((s) => {
          if (s.getBoundingClientRect().top < window.innerHeight * 0.85) return;
          s.classList.add('pt-reveal');
          io.observe(s);
        });
      }
    }
  } catch (e) {
    /* fără reveal = comportament stock */
  }

  const header = document.getElementById('header-component');
  if (!header) return;

  const CLOSE_GRACE_MS = 280;
  const SWITCH_DWELL_MS = 180;
  const LI = '.menu-list__list-item';
  const openLi = () =>
    header.querySelector('.menu-list__list-item:has(.menu-list__link[aria-expanded="true"])');
  const flag = (type, target) => {
    const ev = new PointerEvent(type, { bubbles: false, pointerType: 'mouse' });
    ev.__pt = true;
    target.dispatchEvent(ev);
  };

  /* --- 1. Intenție de hover (doar mouse real) --- */
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    let closeTimer = 0;
    let switchTimer = 0;
    let pendingLi = null;

    const cancelTimers = () => {
      clearTimeout(closeTimer);
      clearTimeout(switchTimer);
      pendingLi = null;
    };

    window.addEventListener(
      'pointerleave',
      (e) => {
        if (e.__pt || !(e.target instanceof Element) || !e.target.matches(LI)) return;
        const open = openLi();
        if (!open || e.target !== open) return;
        e.stopPropagation(); // suprimă /deactivate al Horizon
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          const still = openLi();
          if (still === open && !open.matches(':hover')) flag('pointerleave', open);
        }, CLOSE_GRACE_MS);
      },
      true
    );

    window.addEventListener(
      'pointerenter',
      (e) => {
        if (e.__pt || !(e.target instanceof Element) || !e.target.matches(LI)) return;
        const open = openLi();
        if (open && e.target === open) {
          cancelTimers(); // ne-am întors pe itemul deschis
          return;
        }
        if (!open) return; // nimic deschis: comportament stock (deschidere imediată)
        // alt item cât timp unul e deschis: comută DOAR după dwell
        e.stopPropagation();
        clearTimeout(switchTimer);
        pendingLi = e.target;
        switchTimer = setTimeout(() => {
          const target = pendingLi;
          pendingLi = null;
          if (!target || !target.matches(':hover')) return; // doar traversare, nu comuta
          const still = openLi();
          if (still) flag('pointerleave', still);
          flag('pointerenter', target);
        }, SWITCH_DWELL_MS);
      },
      true
    );

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = openLi();
      if (!open) return;
      cancelTimers();
      flag('pointerleave', open);
    });
  }

  /* --- 3. Re-măsurare după încărcarea fonturilor (overflow corect, fără drawer fals) --- */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      header.querySelectorAll('overflow-list').forEach((ol) => {
        try {
          ol.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
          requestAnimationFrame(() => {
            if (!ol.querySelector('[slot="overflow"]')) {
              ol.removeAttribute('minimum-reached');
              import('@theme/utilities')
                .then((m) => m.setHeaderMenuStyle && m.setHeaderMenuStyle())
                .catch(() => {});
            }
          });
        } catch (err) {
          /* fără reflow = comportament stock */
        }
      });
    });
  }

  /* --- 4. Selectorul de limbă compact: Română -> RO, English -> EN --- */
  header
    .querySelectorAll('.dropdown-localization .localization-form__select option')
    .forEach((opt) => {
      if (opt.value && opt.value.length <= 5) opt.textContent = opt.value.toUpperCase();
    });
})();

/* --- a11y polish (audit 2026-07-10): aditiv, failure-safe --- */
(function () {
  /* inputul de newsletter nu are eticheta accesibila */
  document.querySelectorAll('input[type="email"]:not([aria-label])').forEach(function (i) {
    if (i.labels && i.labels.length) return;
    i.setAttribute('aria-label', i.placeholder || 'E-mail');
  });
  /* linkurile de meniu fara submeniu nu trebuie sa anunte aria-expanded */
  document.querySelectorAll('header a[aria-expanded], .menu-drawer a[aria-expanded]').forEach(function (a) {
    var li = a.closest('li');
    if (li && !li.querySelector('ul, [class*="submenu" i], [class*="dropdown" i]')) {
      a.removeAttribute('aria-expanded');
      a.removeAttribute('aria-haspopup');
    }
  });
})();

/* --- /cart: scoate din „Ți-ar mai putea plăcea" produsele aflate deja în coș
       (audit 2026-07-10; secțiunea product-list e statică). Failure-safe. --- */
(function () {
  if (location.pathname !== '/cart' && location.pathname !== '/en/cart') return;
  fetch('/cart.js')
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (c) {
      if (!c || !c.items || !c.items.length) return;
      var handles = c.items.map(function (i) { return i.handle; });
      document.querySelectorAll('[id*="product_list"] a[href*="/products/"]').forEach(function (a) {
        var m = (a.pathname || '').match(/\/products\/([^/?#]+)/);
        if (!m || handles.indexOf(decodeURIComponent(m[1])) === -1) return;
        var card = a.closest('li') || a.closest('product-card') || a.closest('.product-card');
        if (card) card.style.display = 'none';
      });
    })
    .catch(function () {});
})();
